export enum SocialLoginPlatform {
    FACEBOOK = 'facebook',
    GOOGLE = 'google'
}